import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

const registrableDomain = (hostname: string): string => hostname.split(".").slice(-2).join(".");

// Choose the base URL for GraphQL requests.
//
// On a customer custom domain the SPA must call GraphQL SAME-ORIGIN (relative, empty base)
// so the edge can route /graphql to Django and the cname's session cookie authenticates it
// (a cross-site cookie would be dropped). A custom domain is any host whose registrable
// domain differs from the app host (URL_ORIGINAL_WEBSITE). The primary sp.* host is
// same-site with the app host, so it keeps calling the app host directly (cross-origin but
// same-site, which the session cookie tolerates).
export const graphqlBase = (
  hostname: string = window.location.hostname,
  appWebsite: string = URL_ORIGINAL_WEBSITE
): string => {
  try {
    const appHost = new URL(appWebsite).hostname;
    return registrableDomain(hostname) === registrableDomain(appHost) ? appWebsite : "";
  } catch {
    return appWebsite;
  }
};

export const graphqlUri = (operationName: string, hostname?: string): string =>
  `${graphqlBase(hostname)}/graphql/?op=${encodeURIComponent(operationName)}`;
